import {
    Center, HStack, Text
} from "native-base"
import React from 'react'

export default function EmptyView(props) {
    const { t } = props
    return (
        <Center flex={1}>
            <Text fontSize={'lg'}>{t('noContent')}</Text>
        </Center>
    )
}
